<template>
	<div>
		<vx-card title="Verzend informatie" class="text-md" noShadow cardBorder>
			<div class="vx-row">
				<div class="vx-col w-1/4">
					<h6>Verzonden met:</h6>
					<p>
						{{ order.items[0].transport_code }}
					</p>
				</div>
				<div class="vx-col w-1/4">
					<h6>Verzonden op:</h6>
					<p>{{ order.order.updated_at }}</p>
				</div>

				<div class="vx-col w-1/4" v-if="order.items[0].transport_track_and_trace">
					<h6>Track & Trace:</h6>
					<p>{{ order.items[0].transport_track_and_trace }}</p>
				</div>
				<div class="vx-col w-1/4" v-else-if="!order.items[0].transport_track_and_trace">
					<h6>Track & Trace:</h6>
					<p>
						-
					</p>
				</div>
				<div class="vx-col w-1/4">
					<h6>Verpakking:</h6>
					<p>Onbekend</p>
				</div>
			</div>
		</vx-card>
	</div>
</template>

<script>
export default {
	props: {
		order: Object,
	},
}
</script>
